/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GuildQuestMode } from './GuildQuestMode';
import {
    GuildQuestModeFromJSON,
    GuildQuestModeFromJSONTyped,
    GuildQuestModeToJSON,
    GuildQuestModeToJSONTyped,
} from './GuildQuestMode';
import type { RewardGrant } from './RewardGrant';
import {
    RewardGrantFromJSON,
    RewardGrantFromJSONTyped,
    RewardGrantToJSON,
    RewardGrantToJSONTyped,
} from './RewardGrant';
import type { CreateMilestoneRequest } from './CreateMilestoneRequest';
import {
    CreateMilestoneRequestFromJSON,
    CreateMilestoneRequestFromJSONTyped,
    CreateMilestoneRequestToJSON,
    CreateMilestoneRequestToJSONTyped,
} from './CreateMilestoneRequest';
import type { OWGameEventType } from './OWGameEventType';
import {
    OWGameEventTypeFromJSON,
    OWGameEventTypeFromJSONTyped,
    OWGameEventTypeToJSON,
    OWGameEventTypeToJSONTyped,
} from './OWGameEventType';

/**
 * 
 * @export
 * @interface AddGuildQuestBody
 */
export interface AddGuildQuestBody {
    /**
     * 
     * @type {string}
     * @memberof AddGuildQuestBody
     */
    guild?: string;
    /**
     * 
     * @type {string}
     * @memberof AddGuildQuestBody
     */
    game?: string;
    /**
     * 
     * @type {string}
     * @memberof AddGuildQuestBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AddGuildQuestBody
     */
    description?: string;
    /**
     * 
     * @type {OWGameEventType}
     * @memberof AddGuildQuestBody
     */
    eventType: OWGameEventType;
    /**
     * 
     * @type {number}
     * @memberof AddGuildQuestBody
     */
    target: number;
    /**
     * 
     * @type {boolean}
     * @memberof AddGuildQuestBody
     */
    isActive?: boolean;
    /**
     * 
     * @type {Array<CreateMilestoneRequest>}
     * @memberof AddGuildQuestBody
     */
    milestones?: Array<CreateMilestoneRequest>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddGuildQuestBody
     */
    rewardConfigIds?: Array<string>;
    /**
     * Catalog-item grants (reward-catalog Option B) — additive alongside rewardConfigIds during the migration.
     * @type {Array<RewardGrant>}
     * @memberof AddGuildQuestBody
     */
    rewardGrants?: Array<RewardGrant>;
    /**
     * 
     * @type {boolean}
     * @memberof AddGuildQuestBody
     */
    isGuildQualifier?: boolean;
    /**
     * 
     * @type {GuildQuestMode}
     * @memberof AddGuildQuestBody
     */
    mode?: GuildQuestMode;
    /**
     * 
     * @type {number}
     * @memberof AddGuildQuestBody
     */
    dailyTarget?: number;
}



/**
 * Check if a given object implements the AddGuildQuestBody interface.
 */
export function instanceOfAddGuildQuestBody(value: object): value is AddGuildQuestBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    return true;
}

export function AddGuildQuestBodyFromJSON(json: any): AddGuildQuestBody {
    return AddGuildQuestBodyFromJSONTyped(json, false);
}

export function AddGuildQuestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddGuildQuestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'guild': json['guild'] == null ? undefined : json['guild'],
        'game': json['game'] == null ? undefined : json['game'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'eventType': OWGameEventTypeFromJSON(json['eventType']),
        'target': json['target'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'milestones': json['milestones'] == null ? undefined : ((json['milestones'] as Array<any>).map(CreateMilestoneRequestFromJSON)),
        'rewardConfigIds': json['rewardConfigIds'] == null ? undefined : json['rewardConfigIds'],
        'rewardGrants': json['rewardGrants'] == null ? undefined : ((json['rewardGrants'] as Array<any>).map(RewardGrantFromJSON)),
        'isGuildQualifier': json['isGuildQualifier'] == null ? undefined : json['isGuildQualifier'],
        'mode': json['mode'] == null ? undefined : GuildQuestModeFromJSON(json['mode']),
        'dailyTarget': json['dailyTarget'] == null ? undefined : json['dailyTarget'],
    };
}

export function AddGuildQuestBodyToJSON(json: any): AddGuildQuestBody {
    return AddGuildQuestBodyToJSONTyped(json, false);
}

export function AddGuildQuestBodyToJSONTyped(value?: AddGuildQuestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'guild': value['guild'],
        'game': value['game'],
        'name': value['name'],
        'description': value['description'],
        'eventType': OWGameEventTypeToJSON(value['eventType']),
        'target': value['target'],
        'isActive': value['isActive'],
        'milestones': value['milestones'] == null ? undefined : ((value['milestones'] as Array<any>).map(CreateMilestoneRequestToJSON)),
        'rewardConfigIds': value['rewardConfigIds'],
        'rewardGrants': value['rewardGrants'] == null ? undefined : ((value['rewardGrants'] as Array<any>).map(RewardGrantToJSON)),
        'isGuildQualifier': value['isGuildQualifier'],
        'mode': GuildQuestModeToJSON(value['mode']),
        'dailyTarget': value['dailyTarget'],
    };
}

